import { ref, watch, reactive, computed, onMounted } from '@vue/composition-api'
import useRouter from '../useRouter'
import useUserId from '../useUserId'
import {dashboardUtils} from '../../utils'
import {RequestsService} from '../../services'

import { updatesUseCase } from '../../usecases';
const moment = require('moment');

const useUpdates  = () => {
    const updates = ref([]);
    const loading = ref(false)
    const totalCount = ref(0)
    const unscheduledUpdates = ref([]);

    const {route, router} = useRouter()
    const {userId} = useUserId()

    const must_not = computed(() => {
        const filters = route.value.query.filters ? JSON.parse(route.value.query.filters) : {}
        if(filters.status && filters.status === 'pending') {
            return {
                term: { 
                    "spots.posted": true 
                },
            }
        }
        return null
    })

    const must = computed(() => {

        const mustParams = [];
        const filters = route.value.query.filters ? JSON.parse(route.value.query.filters) : {}

        mustParams.push(
            {
                term: {
                    uid: userId
                }
            },
        );
        
        if(route.value.query.id) {
            mustParams.push({
                term: {
                    _id: route.value.query.id
                }
            })
            return mustParams
        }

        if(route.value.query.id){
            mustParams.push({
                term: {
                    _id: route.value.query.id
                }
            })
            return mustParams
        }

        if(filters.myCampaign){
            mustParams.push({
                term: {
                    'cid': filters.myCampaign
                }
            })
        }

        if(filters.partnerCampaign){

            mustParams.push({
                "exists": {
                    "field": "spots",
                },
            })

            mustParams.push({
                term: { 
                    "spots.cpid": filters.partnerCampaign 
                },
            })
        }

        if(filters.status) {

            mustParams.push({
                "exists": {
                    "field": "spots",
                },
            })

            if(filters.status === 'posted') {
                
    
                mustParams.push({
                    term: { 
                        "spots.posted": true 
                    },
                })
            }
        }

        if(filters.dateRange) {
            mustParams.push(
                {
                    range: {
                        date: {
                            gte: moment.utc(filters.dateRange[0]).format('YYYY-MM-DD'),
                            lte: moment.utc(filters.dateRange[1]).format('YYYY-MM-DD'),
                        }
                    }
                }
            );
        }

        return mustParams
    })


    const setUpdates = async () => {
        
        loading.value = true;

        const page = route.value.query.page - 1 || dashboardUtils.DEFUALT_PAGE;
        const perPage = +route.value.query.perPage || dashboardUtils.DEFAULT_PER_PAGE;

        try {
            if(route.value.query.type === 'unscheduled') {
                const res = await updatesUseCase.getUnscheduledUpdates(userId);
                unscheduledUpdates.value = res.map(item => ({
                    ...item,
                    notExpandable: true
                }))

                const campaignId = route.value.query.filters && JSON.parse(route.value.query.filters).myCampaign
                if(campaignId) {
                    const filteredCampaign = unscheduledUpdates.value.filter(item => item.campaign.id === campaignId);
                    totalCount.value = filteredCampaign.length;
                    updates.value = filteredCampaign;
                } else {    
                    totalCount.value = unscheduledUpdates.value.length;
                    updates.value = unscheduledUpdates.value.slice(page * perPage, page * perPage + perPage);
                }
            } else {
                const res = await updatesUseCase.getUpdatesList(page, perPage, must.value, must_not.value)
                updates.value = res.updates.map(item => {
                    if(item.spots.every(item => !item || item && !item.uid)){
                        return {
                            ...item,
                            notExpandable: true
                        }
                    }
                    return item
                })
                totalCount.value = res.totalCount
            }

        } catch(err) {
            console.log(err);
        } finally {
            loading.value = false;
        }
    }


    watch(route, (newRoute, oldRoute) => {

        if(oldRoute) { 
            if(oldRoute.query.filters !== newRoute.query.filters){
                if(newRoute.query.page) {
                    router.replace({
                        query: {
                            ...newRoute.query,
                            page: undefined
                        }
                    })
                    return
                } 
            }
        }

        setUpdates();
    },  {immediate: true})

    const setPartnersUpdates = async updateData => {

        // check for existing partners' updates data
        const updateDate = updates.value.find(item => item.id === updateData.id)

        if(updateDate.partnerUpdates){
            return;
        }

        updateDate.expandLoading = true;

        try {
            // getting partners' updates data from requests
            const partnerUpdates = await updatesUseCase.getPartnerUpdates(updateData);
            updateDate.partnerUpdates = partnerUpdates

        } catch(e){
            console.log(e)
        } finally {
            updateDate.expandLoading = false;
        }
    }

    return {
        updates, 
        totalCount,
        loading,
        setUpdates,
        setPartnersUpdates,
    }
}

export default useUpdates